import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { GoPerson } from "react-icons/go";
import { RiLockPasswordLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../../redux/authSlice";
import { api1 } from "../../../utils/axiosInstance";
import useLightcastToken from "../../../utils/useLightcastToken";
import { GoogleLogin } from "@react-oauth/google";
import { API_ENDPOINTS } from "../../../services/apiEndpoints";
import { toast } from "react-toastify";
import useGoogleAuth from "../useGoogleAuth";

const SignInForm = () => {
  const { handleGoogleAuth } = useGoogleAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  useLightcastToken();

  const handleData = async (e) => {
    e.preventDefault();

    try {
      const res = await api1.post(API_ENDPOINTS.LOGIN, user, { meta: { showToast: false }});
      if (res.status === 200) {
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        localStorage.setItem("userType", res.data.type);
        dispatch(login(res.data));
        window.dispatchEvent(new Event("accessTokenChanged"));
        
        // Use React Router's navigate instead of window.location to prevent page refresh
        if (!res.data.isProfileComplete) {
          navigate("/dashboard/profile");
        } else if (!res.data.isWelcomeSeen) {
          navigate("/dashboard/welcome");
        } else {
          navigate("/dashboard/home");
        }
      }
    } catch (error) {
       const errMsg =
          error?.response?.data?.message || "Something went wrong. Please try again.";
        toast.error(errMsg);
    }
  };

  const updateUserData = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleFailure = () => {
    console.error("Google login failed");
  };

  return (
    <>
      <div className="w-full flex flex-col items-center justify-center p-4 md:p-8 bg-white overflow-y-auto h-screen">
        <h1 className="text-3xl font-bold text-purple-800 mb-2">
          Welcome to OnTrack Careers!
        </h1>
        <p className="text-gray-500 mb-6">
          Enter your email and password to proceed
        </p>

        <form className="w-full max-w-md">
          <div className="mb-4">
            <div className="flex items-center border border-gray-300 rounded px-3 py-2">
              <GoPerson className="mr-2 text-gray-500" />
              <input
                name="email"
                type="email"
                placeholder="Enter your email here"
                className="w-full outline-none text-gray-700 placeholder:text-sm"
                onChange={updateUserData}
                value={user.email}
              />
            </div>
          </div>

          <div className="mb-4 relative">
            <div className="flex items-center border border-gray-300 rounded px-3 py-2">
              <RiLockPasswordLine className="mr-2 text-gray-500" />
              <input
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password here"
                className="w-full outline-none text-gray-700 placeholder:text-sm"
                onChange={updateUserData}
                value={user.password}
              />
              <div onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <EyeOffIcon className="w-5 h-5 text-gray-500" />
                ) : (
                  <EyeIcon className="w-5 h-5 text-gray-500" />
                )}
              </div>
            </div>
            <p
              onClick={() => navigate("/auth/forget")}
              className="text-right text-sm text-purple-600 mt-2 cursor-pointer hover:underline"
            >
              Forgot your password?
            </p>
          </div>

          <button
            onClick={handleData}
            className="w-full py-3 text-white bg-custom-gradient rounded-lg shadow-md hover:opacity-90 transition-all"
          >
            Login
          </button>
          <div className="flex items-center my-4">
            <hr className="flex-grow border-gray-300" />
            <p className="text-gray-500 px-4">Or</p>
            <hr className="flex-grow border-gray-300" />
          </div>
          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={(res) =>
                handleGoogleAuth({
                  credentialResponse: res,
                  userType: localStorage.getItem("userType") || "user",
                  dispatch
                })
              }
              onError={handleFailure}
              theme="outline" 
              size="large"
              shape="rectangular" 
              width="100%"
            />
          </div>

          {/* <button className="w-full py-3 flex items-center justify-center text-sm font-medium border border-gray-300 rounded-lg mb-3 hover:bg-gray-100 transition-all">
          <img src={googleLogo} alt="Google" className="w-5 h-5 mr-2" />
          Login with Google
        </button> */}
          {/* <button className="w-full py-3 flex items-center justify-center text-sm font-medium border border-gray-300 rounded-lg hover:bg-gray-100 transition-all">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
            alt="Facebook"
            className="w-5 h-5 mr-2"
          />
          Login with Facebook
        </button> */}
        </form>

        <p className="text-sm text-gray-500 mt-4">
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/auth")}
            className="text-purple-600 cursor-pointer hover:underline"
          >
            Sign Up
          </span>
        </p>
      </div>
    </>
  );
};

export default SignInForm;
